<div class="ec-match-container">
  <div class="ec-match-header">
    {{ matchIndex + 1 }}. <span class="supplier-name">{{ supplierData.name }}</span>
    <span class="supplier-tel"
      ><a href="tel:{{ supplierData.phoneNumber }}"
        ><i class="fa fa-phone"></i> {{ supplierData.phoneNumber }}</a
      ></span
    >
  </div>
  <div>
    <div class="job-data-info">
      <div>Existing Job</div>
      <ec-match-job-details [orderInfo]="supplierOrder" [isECJob]="false"></ec-match-job-details>
      <hr />
      <div>Offer Job</div>
      <ec-match-job-details [orderInfo]="ecJob" [isECJob]="true"></ec-match-job-details>
    </div>
    <div style="height: 100%">
      <map-control
        [tasks]="supplierOrder.tasks"
        [suggestedTasks]="ecJob.tasks"
        [readOnly]="true"
        (selectedTaskChange)="taskClick($event)"
        [customStyle]="{ height: '300px' }"
      ></map-control>
    </div>
    <div class="controls-footer">
      <button
        type="button"
        class="green-btn btn-to-right"
        pButton
        icon="fa ui-icon-check"
        (click)="directToSupplier()"
        label="Direct to Supplier"
      ></button>
      <button
        type="button"
        class="green-btn btn-to-right"
        pButton
        icon="fa ui-icon-check"
        (click)="allocateToSupplier()"
        label="Allocate to Supplier"
      ></button>
    </div>
    <div style="clear: both"></div>
  </div>

  <p-dialog
    header="Allocate Job"
    [(visible)]="showAllocateJobDialog"
    [modal]="true"
    [responsive]="true"
    [style]="{ 'max-width': '450px' }"
  >
    <div class="ui-g ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4">Price (£)</div>
        <div class="ui-g-8">
          <input
            type="number"
            name="price"
            autoWidth="false"
            pInputText
            [style]="{ width: '100%' }"
            [(ngModel)]="allocateItem.price"
          />
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12" style="float: right; margin-bottom: 10px">
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="allocateToSupplierSave(allocateItem)"
        label="Allocate"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="showAllocateJobDialog = false"
      ></button>
    </div>
  </p-dialog>
</div>
